import API from './API.js'
import axios from 'axios'

export default class Edu_schemes extends API {
  constructor() {
    super('edu_schemes')
  }
  async getCourse(id) {
    const response = await axios.get(`/edu_schemes/getCourse/${id}`)
    return response.data
  }
  async getOnlineClass(params){
    const response = await axios.get(`/edu-schemes/get-online-class`,{params})
    return response.data
  }
  ///edu-schemes/set-share-contents
  async getShareContents(data){
    const response = await axios.post(`/edu-schemes/set-share-contents`,data)
    return response.data
  }
}
